import type { ModifierArguments } from '@popperjs/core';
import type { CustomPopperProps } from '@wix/thunderbolt-elements/src/providers/usePopper/usePopper';

import { calculateOffset } from './offset';

type GetPopperConfigOptions = {
  rootElement: HTMLDivElement | null;
  referenceElement: HTMLDivElement | null;
  popperElement: HTMLDivElement | null;
};

export const getPopperConfig = ({
  rootElement,
  referenceElement,
  popperElement,
}: GetPopperConfigOptions) => {
  if (!rootElement || !referenceElement || !popperElement) {
    return;
  }

  // in Classic editor, preview iframe on mobile is actually desktop width,
  // causing calculation inaccuracies
  // TODO: this shouldn't be needed, need to raise question to Editor Platform
  const boundaryElement =
    document.getElementById('SITE_CONTAINER') || document.body;

  return {
    placement: 'bottom-start',
    strategy: 'absolute',
    modifiers: [
      {
        name: 'flip',
        options: {
          boundary: 'clippingParents',
          fallbackPlacements: ['top-start', 'bottom-start'],
          allowedAutoPlacements: ['top-start', 'bottom-start'],
        },
      },
      {
        name: 'applyCustomStyles',
        phase: 'write',
        enabled: true,
        fn: ({ state }: ModifierArguments<{}>) => {
          const { placement, modifiersData, styles } = state;
          const popperStyles = {
            ...styles.popper,
          };

          const offsetX = modifiersData.offset?.[placement]?.x ?? 0;
          const offsetY = modifiersData.popperOffsets?.y ?? 0;

          return {
            ...state,
            styles: {
              ...state.styles,
              popper: {
                ...popperStyles,
                transform: `translate(${offsetX}px, ${offsetY}px)`,
              },
            },
          };
        },
      },
      {
        name: 'computeStyles',
        options: {
          adaptive: false,
        },
      },
      {
        name: 'offset',
        options: {
          offset: ({ placement }) =>
            calculateOffset({
              placement,
              rootElement,
              boundaryElement,
              popperElement,
            }),
        },
      },
    ],
  } as CustomPopperProps;
};
